export default "__VITE_ASSET__bvmiXeKp__"